(() => {
  'use strict';
  if (window.TressifineBuyerNotes) return;
  const diySelector = '[data-tfbn-diy]';
  const packSelector = '[data-tfbn-packs]';
  const lengthSelector = '[data-tfbn-length]';
  function updateDiy(root) {
    const output = root.querySelector('[data-tfbn-result]');
    if (!output) return;
    const checks = Array.from(root.querySelectorAll('[data-tfbn-check]'));
    const skills = new Set(checks.map(field => field.dataset.tfbnCheck));
    if (checks.length !== 3 || skills.size !== 3 || !['base', 'secure', 'remove'].every(skill => skills.has(skill))) {
      output.textContent = root.dataset.incomplete;
      return;
    }
    const count = checks.filter(field => field.checked).length;
    output.textContent = count === 3 ? root.dataset.complete : count === 0 ? root.dataset.zero : root.dataset.partial.replace('__COUNT__', String(count));
  }
  function updatePacks(root) {
    const field = root.querySelector('[data-tfbn-pack]');
    const output = root.querySelector('[data-tfbn-result]');
    if (!field || !output) return;
    const count = Number(field.value);
    output.textContent = Number.isInteger(count) && count >= 1 && count <= 4 ? root.dataset.selected.replace('__COUNT__', String(count)).replace('__GRAMS__', String(count * 100)) : root.dataset.empty;
  }
  function updateLength(root) {
    const texture = root.querySelector('[data-tfbn-texture]');
    const length = root.querySelector('[data-tfbn-lengthval]');
    const output = root.querySelector('[data-tfbn-result]');
    if (!texture || !length || !output) return;
    const t = texture.value, l = length.value;
    if (!t || !l) { output.textContent = root.dataset.empty || ''; return; }
    const textureNote = { straight: 'Straighter wave hangs close to its measured length, with only a slight visual shortening.', wave: 'Deep wave eats some visual length, so it looks shorter than the same inches in straight hair.', curly: 'Curly shortens the look the most, so it may need extra inches to reach the same visual drop.' }[t];
    const drop = { 12: 'around shoulder level', 14: 'shoulder to collarbone', 16: 'collarbone to chest', 18: 'mid-chest', 20: 'chest to under-bust', 22: 'under-bust to waist', 24: 'around waist level', 26: 'waist to hip', 28: 'around hip level', 30: 'below the hip' }[l];
    output.textContent = 'Measured length: ' + l + ' inch. ' + textureNote + ' As a starting point only, ' + l + ' inch often falls ' + drop + ' — but this shifts with your height and neck length. Confirm the finished drop with your installer using a straightened measurement.';
  }
  function within(target, selector) {
    const matches = Array.from(target.querySelectorAll(selector));
    if (target.matches?.(selector)) matches.unshift(target);
    return matches;
  }
  function init(target = document) {
    within(target, diySelector).forEach(updateDiy);
    within(target, packSelector).forEach(updatePacks);
    within(target, lengthSelector).forEach(updateLength);
  }
  document.addEventListener('change', event => {
    const target = event.target;
    if (!target?.closest) return;
    if (target.matches('[data-tfbn-check]')) {
      const root = target.closest(diySelector);
      if (root) updateDiy(root);
    }
    if (target.matches('[data-tfbn-pack]')) {
      const root = target.closest(packSelector);
      if (root) updatePacks(root);
    }
    if (target.matches('[data-tfbn-texture], [data-tfbn-lengthval]')) {
      const root = target.closest(lengthSelector);
      if (root) updateLength(root);
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => init());
  window.TressifineBuyerNotes = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
